import gql from 'graphql-tag';
import { DocumentNode } from 'graphql';

export const GET_TEMP_URLS = gql`
query($urls: [String]!, $expirationTime:Int) {
    getTempUrls(urls: $urls, expirationTime:$expirationTime) 
}
`;

export const GET_TUTORIALS = gql`
query Query {
    userTutoriales {
      edges {
        node {
          id
          tutorial
        }
      }
    }
  }
`;

export const SAVE_TUTORIALS = gql`
mutation($input: UserTutorialsMutationInput!){
  userTutorials(input: $input){
        result
    }
  }
`;

export const GET_CLIENT_PERMISSION_QUERY = gql`
  query Query {
    servicios {
      edges {
        node {
            botAsistenciaTecnica
            cursos
            mensajeriaMasiva
            limites
            reporteriaMasiva
            precargaEntidades
            precargaVisitas
            alertas
            capasMapa
            codigosQr
            reportesProfesionales
            descargaMasivaReportes
            rutas
            campanias
        }
      }
    }
  }
`;

export const GET_USER_ROLE = gql`
query{
    currentUser{
        username
        administrador{ __typename}
        cliente{ __typename}
        subcliente{ __typename}
        analista{ __typename}
        profesional{
          id
          entidadesFavoritas
          __typename
        }
        productor{
          id
          persona{
            nombre
            apellido
            imagenPerfil
          }
        }
        persona{
            nombre
            apellido
        }
        usuariopermisos{
          permisos
          estados{
            id
          }
        }
    }
}
`;

export const GET_USER_LANGUAGE = gql `
    query {
        lenguajeCliente {
            key,
            value
        }
    }
`;

export const GET_CLIENT_IDIOM = gql `
    query {
        clientes {
            edges {
                node {
                    idioma
                    pais
                }
            }
        }
    }
`;

export const GET_ESTABLISHMENT_BY_ID = gql`
query Query($id:ID!) {
    entidad(id:$id) {
        id
        nombre
        identificacion
        geolocalizacion
        productor {
          id
          persona {
            nombre
            apellido
            cedula
            telefono
            email
          }
        }
        informacionGeneral
    }
}
`;

export const GET_INFO_CLIENT_RULE = gql`
query{
   normas(tipo_In: "CLIENT_INFO") {
      edges {
         node {
            tipo
            id
            descripcion
            metadata
            capituloSet {
              id
              nombre
              preguntaSet {
                id
                descripcion
                metadata
                anexo
                nombreAnexo
                capitulo{
                  id
                }
                orden
                preguntaCondicionada{
                  id
                }
                tipo{
                  id
                  tipo
                }
                opciones {
                  informacionImportante
                  obligatoria
                  nroFuenteSeparador
                  nombreSeparador
                  puedeAgregarItems
                  visiblePdf
                  continuaEnSeguimiento
                }
                calculada{
                  formula
                }
                sugerencia
                numerica{
                  min
                  max
                  decimalesRequeridos
                  decimales
                }
                respuestaposibleSet{
                  id
                  descripcion
                  metadata
                  preguntasHijas {
                      id
                  }
                  capituloCondicionado {
                      id
                  }
                  respuestasCondicionadas {
                      id
                  }
                }
                esSubpregunta
                esHija
                metadata
              }
            }
         }
      }
   }
}`;